import { render } from "./reset.vue?vue&type=template&id=54390d3d"
const script = {}

import "./reset.vue?vue&type=style&index=0&id=54390d3d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__